import z from "zod";

const nameRegex = /^[A-Za-zА-Яа-яЁёҒғҚқЎўҲҳ\s'`’]+$/;

export const fullNameSchema = z
  .string()
  .trim()
  .min(1, { message: "validation_errors.required_name" })
  .regex(nameRegex, { message: "validation_errors.only_letters_allowed" });
